import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import Link from 'gatsby-link'

import './style.css'

export default class Header extends Component {
  renderMenu() {
    return (
      <div className="nav">
        <nav>
        </nav>
      </div>
    )
  }

  renderNavbar() {
    const { showNav } = this.props
    return (
        <div className="header">
          <span style={{ cursor: 'pointer'}} onClick={e => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}>Tide of Thoughts</span>
        </div>
    )
  }

  render() {
    return (
      this.renderNavbar()
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Header/index.js